import {useEffect, useState} from "react";

const useTags = (initialData, initialTags) => {

    const [selectedTags, setSelectedTags] = useState([])

    useEffect(() => {
        if (initialTags && initialTags.length > 0) {
            setSelectedTags(initialTags)
        }
    }, [initialTags])

    const displayTagAccordingToParent = (id) => {
        setSelectedTags(initialData.filter(d => d.id === id).map(d => d.tags)[0])
    }

    return {selectedTags, setSelectedTags, displayTagAccordingToParent}
}

export default useTags